import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './AppRoutes';
import Navbar from './components/Navbar';
import { auth } from './utils/firebase';
import { setPersistence, browserLocalPersistence } from 'firebase/auth';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';

const App: React.FC = () => {
  const [isFirebaseInitialized, setIsFirebaseInitialized] = useState(false);

  useEffect(() => {
    const initializeFirebase = async () => {
      try {
        console.log('App - Setting up Firebase persistence');
        await setPersistence(auth, browserLocalPersistence);
        console.log('App - Firebase initialized');
        setIsFirebaseInitialized(true);
      } catch (error) {
        console.error('App - Firebase initialization error:', error);
        // Still set as initialized to prevent infinite loading
        setIsFirebaseInitialized(true);
      }
    };

    initializeFirebase();
  }, []);

  if (!isFirebaseInitialized) {
    return (
      <div className="min-h-screen bg-dream-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dream-400"></div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <SEO />
          <div className="min-h-screen bg-dream-900">
            <Navbar />
            <div className="pt-16">
              <AppRoutes />
            </div>
          </div>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App; 